import React, { useState, useEffect, useCallback, useRef } from "react";
import I18n from "i18n-js";

const SuccessFlashMessage = ({
  showSuccessFlashMessage,
  setShowSuccessFlashMessage,
  successMessage
  }) => {

  useEffect(() => {
    if (showSuccessFlashMessage === true) {
      setTimeout(() => { setShowSuccessFlashMessage(false) }, 2000);
    }
  }, [showSuccessFlashMessage]);

  return <div className={`success-flash-message text-center z-index-125 ${!showSuccessFlashMessage ? 'd-none' : ''}`}>
    {successMessage ? successMessage : I18n.t('js.common.successMessage')}
  </div>
};

export default SuccessFlashMessage;